import type { GridApi } from 'ag-grid-community';
import { isCurrencyField } from '../utils/field-utils';

export function exportCSV(gridApi: GridApi | null): void {
  if (!gridApi) return;

  const date = new Date().toISOString().split('T')[0].replace(/-/g, '');
  const filename = `chickpeace-filtered-${date}.csv`;

  gridApi.exportDataAsCsv({
    fileName: filename,
    columnSeparator: ';',
    processCellCallback: (params) => {
      if (isCurrencyField(params.column.getColId()) && typeof params.value === 'number') {
        return params.value.toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR'
        });
      }
      return params.value;
    }
  });
}
